var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { ContentTabs } from '../elements/content-tabs';
import { useView } from '../hooks/use-view';
import { useEntityContentTabs } from '../hooks/use-entity-content-tabs';
var cls = classNames('entity-view-tabs');
export var EntityViewTabsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityViewTabs',
  Container: styled(ContentTabs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityViewTabs = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, EntityViewTabsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var color = entity.color;
  // build the content tabs spec
  var tabs = useEntityContentTabs(entity);
  // if there is only one tab, don't render the tabs
  if (tabs.length <= 1) {
    return null;
  }
  var _b = useView(entity.path, (_a = tabs.find(function (tab) {
      return tab.isDefault;
    })) === null || _a === void 0 ? void 0 : _a.id),
    activeView = _b.activeView,
    setActiveView = _b.setActiveView;
  return React.createElement(My.Container, {
    activeTab: activeView,
    className: cls.name(className),
    items: tabs,
    onTabClick: setActiveView,
    colors: {
      border: color === null || color === void 0 ? void 0 : color.value,
      hover: {
        text: color === null || color === void 0 ? void 0 : color.value
      }
    }
  });
};
EntityViewTabs.cls = cls;
var templateObject_1, templateObject_2;